import { create } from "zustand";
import { produce } from "immer";

export const useMenu = create((set) => ({
  data: {
    open: true,
    size: "16rem",
    itens: {},

  },
  actions: {
    toggleSize: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.open = !state.data.open
          draft.data.size = state.data.open ? "4.5rem" : "16rem"
        })
      ),
    setItem: (item) =>
      set((state) =>
        produce(state, (draft) => {
          if (!item.name) return
          if (!!state.data.itens[item.name]) return
          draft.data.itens[item.name] = {
            name: item.name,
            open: item.open || false,
            active: item.active || false,
            submenu: item.submenu || false,
          };
          state.data.itens[item.name]
        })
      ),
    toggleItem: (name) =>
      set((state) =>
        produce(state, (draft) => {
          if (!state.data.itens[name]) return
          draft.data.itens[name].open = !state.data.itens[name].open
        })
      ),
    setActive: (name) =>
      set((state) =>
        produce(state, (draft) => {
          if (!state.data.itens[name]) return
          if (state.data.itens[name].active) return

          Object.keys(state.data.itens).forEach((key) => {
            if (key !== name) draft.data.itens[key].active = false
            if (key === name) draft.data.itens[key].active = true
          })
        })
      ),
  },
}));
